'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/iterators.js
// module id = 87
// module chunks = 13